export default function toFixed(n, fixed) {
    const val = ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed);
    return val
  }